import { BrowserStorageType } from "@front-shared/config/general.config"
import { BrowserStorageHelper } from "@front-shared/helpers/browserStorage.helper"

import { GENERAL_CONFIG } from "../config/general.config"
import type { IEmbedCalculatorState } from "../types/state.types"

export class EmbedCalculatorStateClass implements IEmbedCalculatorState {
    // Once page reload we'd like to set it as initial state
    embedKey =
        BrowserStorageHelper.get<string>(
            GENERAL_CONFIG.browserStorageKeys.embedKey,
            undefined,
            BrowserStorageType.sessionStorage,
        )?.toString() || undefined

    managementKey = null

    checkedEmbedKey = null
}
